import { render, staticRenderFns } from "./Iclaim.vue?vue&type=template&id=1e2e2cf0&"
import script from "./Iclaim.vue?vue&type=script&lang=js&"
export * from "./Iclaim.vue?vue&type=script&lang=js&"
import style0 from "./Iclaim.vue?vue&type=style&index=0&id=1e2e2cf0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports